import type { AnimanCredential, PageContext } from './types';
import { generateUID } from '../utils/StringUtil';

// WebSocket instance
let _socket: WebSocket | null = null;
export function getSocket(): WebSocket | null { return _socket; }
export function setSocket(ws: WebSocket | null) { _socket = ws; }

// Generating state
let _isGenerating = false;
export function getIsGenerating(): boolean { return _isGenerating; }
export function setIsGenerating(val: boolean) { _isGenerating = val; }

// Reconnect interval (exponential backoff)
let _reconnectInterval = 1000;
export function getReconnectInterval(): number { return _reconnectInterval; }
export function setReconnectInterval(val: number) { _reconnectInterval = val; }

// Page context from parent window
let _pageContext: PageContext = { url: '', content: {} };
export function getPageContext(): PageContext { return _pageContext; }
export function setPageContext(ctx: PageContext) { _pageContext = ctx; }
export function updatePageContextContent(content: Record<string, any>) {
    Object.assign(_pageContext.content, content);
}

// Page context from parent window
let _credential: AnimanCredential = { sessionId: generateUID(), clientUser: {}, token: '' };
export function getCredential(): AnimanCredential { return _credential; }
export function setCredential(credential: AnimanCredential) { _credential = credential; }
export function updateCredential(content: AnimanCredential) {
    if (_credential.token !== content.token) {
        _credential.sessionId = generateUID();
    }
    _credential.clientUser = content.clientUser;
    _credential.token = content.token;
}
export function refreshSessionId() { _credential.sessionId = generateUID(); }

// Welcome screen container reference
export function getWelcomeContainer(): HTMLDivElement | null { return document.querySelector('.welcome-container'); }
